module.exports = __webpack_public_path__ + "img/a3.2f4faefa.jpg";